import { readUiPreference, writeUiPreference } from '@/lib/preferences/ui-preferences';

/**
 * 「這份資料是從哪裡匯進來的」（desktop-app.md 4.3）。
 *
 * 匯入一律是取代或合併整份資料，之後使用者很容易忘記自己看的是哪一份。
 * 工具列標一行「匯自 09-02 本機版備份」就能立刻分辨。
 *
 * 存在 localStorage 而不是 settings：它是**這台機器的畫面提示**，
 * 不該跟著備份檔一起被匯出到別的地方去（在那裡它會是錯的）。
 */

const KEY = 'ui.import.lastSource' as const;

export interface ImportSourceMark {
  /** 例如「本機版備份」「完整備份」「任務清單備份」。 */
  label: string;
  /** 匯入當下的本地日期，MM-DD。 */
  stamp: string;
}

export function markImportSource(label: string, at: Date = new Date()): void {
  const pad = (value: number) => value.toString().padStart(2, '0');
  writeUiPreference<ImportSourceMark>(KEY, {
    label,
    stamp: `${pad(at.getMonth() + 1)}-${pad(at.getDate())}`,
  });
}

export function readImportSource(): ImportSourceMark | null {
  const value = readUiPreference<ImportSourceMark | null>(KEY, null);
  if (!value || typeof value.label !== 'string' || typeof value.stamp !== 'string') return null;
  return value;
}

export function describeImportSource(mark: ImportSourceMark | null): string | null {
  return mark ? `匯自 ${mark.stamp} ${mark.label}` : null;
}
